import { styled } from "@mui/material/styles";
import { DreamMarkdownReader } from "@portal/app/_components/ui-elements/DreamMarkdown/DreamMarkdownReader";

export const ContactDisclaimer = ({ 
  type, 
  customText 
}: { 
  type: "PHONE" | "EMAIL" | "ALL";
  customText?: string;
}) => {
  const getDefaultMarkdownText = () => {
    const method =
      type === "EMAIL"
        ? "email"
        : type === "PHONE"
          ? "call or text (message & data rates may apply)"
          : "call, text, or email (message & data rates may apply)";

    return `Heads up: Dreambound may use your information to send you relevant communications through ${method}. By creating an account, you agree to our [Terms and Conditions](https://dreambound.com/terms-and-conditions) and [Privacy Policy](https://dreambound.com/privacy-policy).`;
  };

  const markdownText = customText || getDefaultMarkdownText();

  return (
    <StyledDreamMarkdownReader 
      value={markdownText}
      data-testid={`${type.toLowerCase()}-disclaimer`}
    />
  );
};

const StyledDreamMarkdownReader = styled(DreamMarkdownReader)`
  font-size: 0.75rem;
  line-height: 1.66;
  
  .editor-paragraph {
    margin: 0;
  }
  
  a {
    color: inherit;
    text-decoration: underline;
  }
`;
